import React from "react";
import {TableLink} from "peggirkit";
import {FormattedMessage} from "react-intl";
import ViewFormatter from "@widgets/employees/overview/table/columns/ViewFormatter";
import {editLoyaltyReward} from "@/routing/Router";
import {LoyaltyRewardDetails} from "@/data/entities/loyaltyReward";
import {SetStateFn} from "@/utils/SetStateUtils";
import {DeleteLoyaltyRewardState} from "@widgets/loyaltyRewards/delete/DeleteLoyaltyRewardModal";

type Props = {
    deleteLoyaltyRewardState: SetStateFn<DeleteLoyaltyRewardState>,
    loyaltyReward: LoyaltyRewardDetails,
};

const OptionsFormatter = ({loyaltyReward, deleteLoyaltyRewardState}: Props) => {
    return (
        <div className={"flex flex-row flex-nowrap items-center justify-end gap-6"}>
            <TableLink
                color={"danger"}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            deleteLoyaltyRewardState({
                                showModal: true,
                                loyaltyRewardId: loyaltyReward.id,
                            });
                        },
                    }
                }}
            >
                <FormattedMessage id={"delete"}/>
            </TableLink>

            <ViewFormatter
                disabled={loyaltyReward.product === null}
                to={
                    loyaltyReward.product === null
                        ? "#"
                        : editLoyaltyReward(loyaltyReward.id).absolutePath()
                }
            />
        </div>
    );
};

export default OptionsFormatter;